module.exports = __webpack_public_path__ + "static/img/home_foto4.edab76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home_foto4.png
// module id = 83
// module chunks = 0